export const generativeAiAgentId = "/generative_ai/agent/:id";
